import {TextInputEnum} from '../../../utilities/validation/InputValidation';
export const LoginFieldsByType: {
  [key: string]: {
    title? : string ,
     fields: {
      name : string ,
      type : TextInputEnum ,
      placeholder : string ,
      isNumeric : boolean ,
      maxLength : number ,
     }[]
  };
} = {
  ORGANIZATIONEMPLOYEECREDENTIALS: {
    title: 'היי, טוב לראות אותך',
    fields: [
        {
        name: 'idNumber',
        type: TextInputEnum.Id,
        placeholder: 'מספר ת.ז',
        isNumeric: true,
        maxLength: 9,
      },{
        name: 'subscriber',
        type: TextInputEnum.Phone,
        placeholder: 'מספר טלפון',
        isNumeric: true,
        maxLength: 10,
      }
    ],
  },
  ORGANIZATIONEMPLOYEEFAMILY: {
    title: 'כמה פרטים ונתקדם',
    fields: [
        {
        name: 'subscriber',
        type: TextInputEnum.Phone,
        placeholder: 'מס הטלפון שלך' ,
        isNumeric: true,
        maxLength: 10,
      },{
        name: 'customValue',
        type: TextInputEnum.Phone,
        placeholder: 'מס הטלפון של נותן ההטבה',
        isNumeric: true,
        maxLength: 10,
      }
    ],
  },
};
